query ReportsList($page: Int, $rowsPerPage: Int, $filter: ReportsFilterInput) {
  reports(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      type
      widget
      filter
      status
      progress
      rowCount
      fileName
      error {
        code
        message
      }
      creator {
        id
        email
      }
      createdAt
      completedAt
      downloadedAt
      expiresAt
    }
  }
}
